import {
  Alert,
  AlertTitle,
  AlertDescription,
} from '@dc-shared-web/components/shadcn/alert'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { Icon } from '@dc-shared-web/components/base/Icon'
import { cn } from '@dc-shared-web/lib'

export type BaseAlertProps = {
  /** Title of the alert */
  title?: string
  /** Variant of the alert, defaults to 'default' */
  variant?: 'default' | 'info' | 'destructive' | 'warning' | 'success'
  /** Icon of the alert*/
  icon?: IconDefinition
  /** Description of the alert - can be a string or React node */
  description?: string | React.ReactNode
  /** Action slot of the alert. Can be used to add a button to the alert (e.g. a close button) */
  actionSlot?: React.ReactNode
  /** Class name of the alert */
  className?: string
}

export default function BaseAlert({
  variant,
  icon,
  title,
  description,
  actionSlot,
  className,
}: BaseAlertProps) {
  return (
    <Alert
      variant={variant}
      className={cn(
        'tw-flex tw-items-center tw-justify-between tw-w-full tw-gap-3',
        className
      )}
    >
      <div className='tw-flex tw-items-center tw-gap-3'>
        {icon && (
          <Icon
            icon={icon}
            className={cn('tw-h-4 tw-w-4', title && 'tw-self-start')}
          />
        )}
        <div>
          {title && <AlertTitle className='tw-mb-1'>{title}</AlertTitle>}
          {description && (
            <AlertDescription className='tw-whitespace-pre-line'>
              {description}
            </AlertDescription>
          )}
        </div>
      </div>
      {actionSlot && (
        <div className='tw-flex tw-items-center tw-justify-end tw-shrink-0'>
          {actionSlot}
        </div>
      )}
    </Alert>
  )
}
